import { getSimilarityPercentage } from './stringUtils'

const allowEventMethods = [
  'function(n,r,o){try{"function"===typeof r.handleEvent&&(r.handleEvent=Object(c.c)(r.handleEvent.bind(r),{mechanism:{data:{function:"handleEvent",handler:Object(a.a)(r),target:e},handled:!0,type:"instrument"}}))}catch(i){}return t.call(this,n,Object(c.c)(r,{mechanism:{data:{function:"addEventListener",handler:Object(a.a)(r),target:e},handled:!0,type:"instrument"}}),o)}',
]

/**
 * Detects if a prototype function has been tampered with by comparing its string representation
 * to the expected native code format.
 * @param {Object} target - The target object containing the prototype
 * @param {string} eventName - The name of the event/function to check
 * @returns {boolean} - True if tampering is detected, false otherwise
 */
export const detectPrototypeFunctionTampering = (target, eventName) => {
  // Early return for invalid inputs
  if (target == null || typeof eventName !== 'string') {
    return false
  }

  try {
    const prototype = target.prototype
    if (!prototype) {
      return false
    }

    const targetFunction = prototype[eventName]
    if (typeof targetFunction !== 'function') return false

    const targetFunctionString = targetFunction.toString()

    // Check if it's native code
    if (targetFunctionString === `function ${eventName}() { [native code] }`) {
      return false
    }

    // Check similarity with all allowed event listener methods eg. sentry event listener
    for (const allowedMethod of allowEventMethods) {
      if (getSimilarityPercentage(targetFunctionString, allowedMethod) > 85) {
        return false
      }
    }

    return true
  } catch {
    return false
  }
}
